const autocompleteModalEquipService = {
  serviceType: 'Service Type',
  frequency: 'Frequency',
  mandatory: 'Service is mandatory?',
  expirationOnLastDayOfMonth: 'Expiration at the end of the month',
  allowMassService: 'Allow create mass service',
  mandatoryActions: "Are Actions mandatory for questions with answer 'Doesn't comply'?",
  enableSignature: 'Enable Signature',
  mandatorySignature: 'Mandatory Signature',
};

export default autocompleteModalEquipService;
